export type KnownSiteNamesType = 'Axetris' | 'LeisterGroup' | 'LeisterTechnologies' | 'Weldy';

export const KnownSiteNames: { [K in KnownSiteNamesType]: KnownSiteNamesType } = {
  Axetris: 'Axetris',
  LeisterGroup: 'LeisterGroup',
  LeisterTechnologies: 'LeisterTechnologies',
  Weldy: 'Weldy'
};
